<template>
  <div>
    <component :is="component(section.flexLayout)" v-for="section in sections" :content="section" :key="section.flexKey"
               :class="['py-20 md:py-25 transition-[padding]', background(section.background)]"/>
  </div>
</template>

<script lang="ts">
import {ContentCardsSection, DropdownsSection, ImagesSection, LinksSection, RichTextSection, TextImageSection, FeaturedNewsSection, FeaturedEventsSection} from '@/components/sections/repeatable'
import type {PropType} from "vue";

export default {
  name: 'PageSections',
  props: {
    sections: {
      type: Array as PropType<RepeatableSection[]>,
      required: true,
    }
  },
  methods: {
    background(value?: string) {
      if (!value) return ''

      let styleClass = `bg-${value?.split('_')[0]}`

      if (styleClass.includes('main-color')) {
        styleClass += ' white-text'
      }

      return styleClass
    },
    component(type: sectionType) {
      switch (type) {
        case 'content-cards-section':
          return ContentCardsSection
        case 'dropdown-section':
          return DropdownsSection
        case 'featured-events-section':
          return FeaturedEventsSection
        case 'featured-news-section':
          return FeaturedNewsSection
        case 'images-section':
          return ImagesSection
        case 'links-section':
          return LinksSection
        case 'rich-text-section':
          return RichTextSection
        case 'text-image-section':
          return TextImageSection
      }
    }
  }
}
</script>
